export default "__VITE_ASSET__0biRDesA__"